import { Chip } from "@mui/material";

const useGlobal = () => {
  const getActiveBadge = (status: boolean) => {
    switch (status) {
      case true:
        return <Chip label={"Active"} color="success" size="small" />;
      case false:
        return <Chip label={"Inactive"} color="error" size="small" />;
      default:
        return <Chip label={"Not available"} size="small" />;
    }
  };

  const getOnlineBadge = (status: boolean) => {
    switch (status) {
      case true:
        return <Chip label={"Online"} color="success" size="small" />;
      case false:
        return <Chip label={"Offline"} color="warning" size="small" />;
      default:
        return <Chip label={"Not available"} size="small" />;
    }
  };

  const getActivityBadge = (activity: string) => {
    switch (activity) {
      case "task_creation":
        return <Chip label={"Task Creation"} color="info" size="small" />;
      case "keyin":
        return <Chip label={"KeyIn"} color="warning" size="small" />;
      case "support":
        return (
          <Chip
            label={"Support"}
            size="small"
            sx={{ color: "#662bd6", backgroundColor: "#ece9fe" }}
          />
        );
      case "qc":
        return (
          <Chip
            label={"QCAnswer"}
            size="small"
            sx={{ color: "#662bd6", backgroundColor: "#ece9fe" }}
          />
        );
      default:
        return <Chip label={"Not available"} size="small" />;
    }
  };

  const getOrderTypeOptions = () => {
    const orderTypeOptions = [
      {
        label: "Stock",
        value: "stock",
        chip: <Chip label="Stock" size="small" color="grey" />,
      },
      {
        label: "RX",
        value: "rx",
        chip: <Chip label="RX" size="small" color="secondary" />,
      },
    ];

    return orderTypeOptions;
  };

  const getOrderCycleOptions = () => {
    const orderCycleOptions = [
      {
        label: "Morning",
        value: "morning",
        chip: <Chip label="Morning" size="small" color="info" />,
      },
      {
        label: "Afternoon",
        value: "afternoon",
        chip: <Chip label="Afternoon" size="small" color="warning" />,
      },
      {
        label: "Overdue",
        value: "overdue",
        chip: <Chip label="Overdue" size="small" color="error" />,
      },
    ];

    return orderCycleOptions;
  };

  const getOrderCycleBadge = (value: string) => {
    const orderCycle = getOrderCycleOptions().find((oc) => oc.value === value);
    if (orderCycle) return orderCycle.chip;
    return "";
  };

  const getRoleBadge = (role: string) => {
    switch (role) {
      case "admin":
        return <Chip label={"Admin"} color="success" size="small" />;
      case "member":
        return <Chip label={"User"} color="info" size="small" />;
      case "crm":
        return <Chip label={"CRM"} color="secondary" size="small" />;
      case "reward":
        return <Chip label={"Reward"} color="warning" size="small" />;
    }
  };

  return {
    getActiveBadge,
    getOnlineBadge,
    getActivityBadge,
    getOrderTypeOptions,
    getOrderCycleOptions,
    getOrderCycleBadge,
    getRoleBadge,
  };
};

export default useGlobal;
